<template>
	<div class="lowpriced-page">

		<el-breadcrumb style="margin-bottom:30px;" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item class="first-breadcrumb">{{ $t("SidebarMenu.Menu06") }}</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: '/SPU/PriceMonitoring/' + $route.params.Id }">{{ defalutbrand }}</el-breadcrumb-item>
			<el-breadcrumb-item>{{ $t('jgjk.s999') }}</el-breadcrumb-item>
		</el-breadcrumb>
		
		<div class="lowpriced-page-table">

      <div class="searchwrap">
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form :inline="true" class="table-form-inline search-left">
              <el-form-item :label="$t('jgjk.s12')">
                <el-select v-model="filterselector[0].default" :placeholder="$t('dsfx.t14')" size="mini" @change="filters0change">
                  <el-option
                    v-for="item in filterselector[0].options"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item :label="$t('dsfx.t23')">
                <el-select v-model="filterselector[3].default" :placeholder="$t('dsfx.t14')" size="mini" @change="filters3change">
                  <el-option
                    v-for="item in filterselector[3].options"
                    :key="item.value"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="12">
            <div class="tousuxiajiabuttonwrap">
              <el-input 
                v-model="tableviewQuery.search" 
                :placeholder="$t('jgjk.s2652')" 
                size="mini" 
                @keyup.enter.native="onTableListSaerchClick()"
              >
              </el-input>
              <el-button type="danger" @click="onTableListSaerchClick()" size="mini">{{ $t('dsfx.t26') }}</el-button>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="tablebox">
        <el-table
          :cell-style="getTableCellStyle"
          v-loading="tableloading" 
          ref="multipleTable" 
          :data="tableData" 
          tooltip-effect="dark" 
          style="width: 100%" 
          @sort-change="sortthiscolumn"
          @expand-change="getProductList"
          :expand-row-keys="expands"
          :row-key="getRowKeys"
        >
          <el-table-column width="30" type="expand">
            <template slot-scope="scope">
              <div class="tablebox">
                <el-table
                  :cell-style="getTableCellStyle"
                  v-loading="tableloading1" 
                  ref="multipleTable" 
                  :data="tableDataSku[scope.row.index]"
                  tooltip-effect="dark" 
                  style="width: 100%" 
                  @sort-change="sortthiscolumn"
                  border
                  size="mini"
                  stripe
                >
                  <el-table-column prop="AssetId" label="ASSETID" width="100" show-overflow-tooltip></el-table-column>
                  <!-- <el-table-column :label="$t('SPU.s5')" show-overflow-tooltip>
                    <template slot-scope="scope1">
                      <a :href="scope1.row.URL" target="_blank">{{ scope1.row.ProductName }}</a>
                    </template>
                  </el-table-column> -->
                  <el-table-column prop='skuMap' :label="$t('jgjk.s266')" show-overflow-tooltip></el-table-column>
                  <el-table-column prop='CurrentPrice' :label="$t('jgjk.s23')" width="95" show-overflow-tooltip></el-table-column>
                  <el-table-column prop='FinalPrice' :label="$t('jgjk.s24')" width="120" show-overflow-tooltip></el-table-column>
                  <el-table-column prop='MarginPrice' :label="$t('jgjk.s26')" width="80" show-overflow-tooltip></el-table-column>
                  <el-table-column prop='MarginPercent' :label="$t('report.s38')" width="100" show-overflow-tooltip></el-table-column>
                  <el-table-column :label="$t('jgjk.s31')" width="90">
                    <template slot-scope="scope1">
                      <!-- <button v-if="userinfo.role/1 == 0 || userinfo.role/1 == 2" class="editskulinkbtn" type="button" @click="editSkuLink(scope1.row)"><i class="el-icon-edit-outline"></i></button> -->
                      <button class="viewactivebrand" type="button" @click="viewUrlDetail(scope1.row.AssetId, scope1.row.ProductName)"></button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="spuid" label="SPUID" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="productName" :label="$t('jgjk.s15')" show-overflow-tooltip></el-table-column>
          <el-table-column :label="$t('jgjk.s12')" width="80">
            <template slot-scope="scope">
              <i class="channelicon" :class="scope.row.channelicon"></i>
            </template>          
          </el-table-column>
          <el-table-column :label="$t('activebrand.t50')" width="200" show-overflow-tooltip>
            <template slot-scope="scope">
              <a :href="scope.row.ShopUrl" target="_blank">{{ scope.row.shopname }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="pageprice" :label="$t('jgjk.s23')" width="100"></el-table-column>
          <el-table-column prop="MarginPercent" :label="$t('report.s51')" width="100"></el-table-column>
          <el-table-column prop='authorize' :label="$t('jgjk.s21')" width="60" show-overflow-tooltip></el-table-column>
          <el-table-column prop="count" :label="$t('SPU.s2')" width="100"></el-table-column>
        </el-table>
      </div>

      <div class="pagewrap">
        <el-pagination
          small
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage1"
          popper-class="pagesizeclass"
          :page-sizes="[25, 50, 100]"
          :page-size="pagesize"
          layout="total, prev, pager, next, sizes"
          :total="pagingtotal">
        </el-pagination>      
      </div>

		</div>

	</div>
</template>

<script>
export default {

	data(){
		return{
      getRowKeys(row){
        return row.index
      },
      expands: [],
      defalutbrand: '',
      currentPage1: 1,
      pagesize: 25,
      pagingtotal: 0,
      tableviewQuery: {
        page: 1,
        rpstatus: "",
        channel: "",
        result: "",
        bucket: "",
        search: "",
        brand: "",
        authorize: ""
      },
      tableloading: false,
      tableloading1: false,
			tableorder: 50,
			tableData: [],
      tableDataSku: [],
      series: '',
      model: '',
      userinfo: JSON.parse(localStorage.getItem("userinfo")).val,
      editskulinkdialog: false,
      currentlinkeditcontent: '',
      filterselector: [{
          fieldid: "Channel",
          source: "channel",
          options: [],
          default: ''
      },{
          fieldid: "Result",
          source: "result",
          options: [{
            name: this.$t('tabletabs.all'),
            value: ''
          },{
            name: this.$t('DashboardProduct.barlegendnamefalse'),
            value: 0,
          },{
            name: this.$t('DashboardProduct.barlegendnametrue'),
            value: 1,
          }],
          default: ''
      },{
          fieldid: "Bucket",
          source: "bucket",
          options: [{
            name: '全部',
            value: ''
          },{
            name: '低',
            value: 3,
          },{
            name: '中',
            value: 2,
          },{
            name: '高',
            value: 1,
          }],
          default: ''
      },{
          fieldid: "Authorize",
          source: "authorize",
          options: [{
            name: this.$t('tabletabs.all'),
            value: ''
          },{
            name: this.$t('dsfx.t53'),
            value: 0,
          },{
            name: this.$t('dsfx.t52'),
            value: 1,
          }],
          default: ''
      }],
      taskid: ''
		}
	},

	mounted(){
		this.getPricemonitoring()
    this.requestTabAndDropdownData()
    this.getLowpricedLists()
  },
  
  computed: {
    listenpriceSeries(){
      return this.$store.state.priceSeries
    },
    listenpriceModel(){
      return this.$store.state.priceModel
    }
  },

	methods: {

    /**
     * filters0change
     */
    filters0change: function(val){
      this.filterselector[0].default = val === '全部' ? '' : val
      this.disableOptionsRefresh = true
      this.getLowpricedLists()
    },

    /**
     * filters3change
     */
    filters3change: function(val){
      this.filterselector[3].default = val === '全部' ? '' : val
      this.disableOptionsRefresh = true
      this.getLowpricedLists()
    },

		/**
		 * 每页显示条目数切换
		 */
    handleSizeChange(val) {
      let that = this
      that.currentPage1 = 1
      that.tableviewQuery.page = 1
      that.pagesize = val
      this.getLowpricedLists()
		},
		
		/**
		 * 翻页
		 */
    handleCurrentChange(val) {
      this.tableviewQuery.page = val
      this.getLowpricedLists()
    },

    /**
     * 获取品牌
     */
    getPricemonitoring: function(){
      let that = this
      let priceArr = JSON.parse(localStorage.getItem("price")).val
      for(let i=0; i<priceArr.length; i++){
        if(priceArr[i].subid/1 === that.$route.params.Id/1){
          that.defalutbrand = priceArr[i].name
          that.taskid = priceArr[i].taskid
        }
      }
		},

    /**
     * 列表排序
     */
    sortthiscolumn: function(column){
      if(column.prop == "CurrentPrice" && column.order == "ascending"){
        this.tableorder = 10
        this.reloadTableData()
      }else if(column.prop == "CurrentPrice" && column.order == "descending"){
        this.tableorder = 11
        this.reloadTableData()
      }else if(column.prop == "CurrentPrice" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "FinalPrice" && column.order == "ascending"){
        this.tableorder = 20
        this.reloadTableData()
      }else if(column.prop == "FinalPrice" && column.order == "descending"){
        this.tableorder = 21
        this.reloadTableData()
      }else if(column.prop == "FinalPrice" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "MonitorPrice" && column.order == "ascending"){
        this.tableorder = 30
        this.reloadTableData()
      }else if(column.prop == "MonitorPrice" && column.order == "descending"){
        this.tableorder = 31
        this.reloadTableData()
      }else if(column.prop == "MonitorPrice" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "MarginPrice" && column.order == "ascending"){
        this.tableorder = 40
        this.reloadTableData()
      }else if(column.prop == "MarginPrice" && column.order == "descending"){
        this.tableorder = 41
        this.reloadTableData()
      }else if(column.prop == "MarginPrice" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "MarginPercent" && column.order == "ascending"){
        this.tableorder = 50
        this.reloadTableData()
      }else if(column.prop == "MarginPercent" && column.order == "descending"){
        this.tableorder = 51
        this.reloadTableData()
      }else if(column.prop == "MarginPercent" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "last30times" && column.order == "ascending"){
        this.tableorder = 70
        this.reloadTableData()
      }else if(column.prop == "last30times" && column.order == "descending"){
        this.tableorder = 71
        this.reloadTableData()
      }else if(column.prop == "last30times" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else if(column.prop == "SkuTotalAmountStr" && column.order == "ascending"){
        this.tableorder = 60
        this.reloadTableData()
      }else if(column.prop == "SkuTotalAmountStr" && column.order == "descending"){
        this.tableorder = 61
        this.reloadTableData()
      }else if(column.prop == "SkuTotalAmountStr" && column.order == null){
        this.tableorder = ''
        this.reloadTableData()
      }else{
        return
      }
		},

		/**
		 * 重载数据
		 */
		reloadTableData: function(){
			this.getLowpricedLists()
		},
		
		/**
		 * 获取低价链接
		 */
		getLowpricedLists: function(){
			
      let that = this
			let url = that.API_URL + '/v3/price/monitorspu/lowPricelist'
			let query ={
        subid: that.$route.params.Id,
        page: that.tableviewQuery.page,
        size: that.pagesize,
        order: that.tableorder,
        channel: that.filterselector[0].default,
        authorize: that.filterselector[3].default,
        search: that.tableviewQuery.search
			}
			that.tableloading = true
      $.ajax({
        url: url,
        type: "GET",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        data: query,
        success: function(rex) {
					console.log('getLowpricedLists', rex)
          let _lists = rex.results[0]
          _lists.forEach((item, index) => {
            item.channelicon = that.setChannel(item.channel).src
            item.pageprice = item.minFinalPrice == item.maxFinalPrice ? item.maxFinalPrice : item.maxFinalPrice + '-' + item.maxFinalPrice
            item.MarginPercent = (item.MarginPercent * 100).toFixed(2) + "%"
            item.authorize = item.IsAuthor/1 === 0 ? that.$t('dsfx.t53') : that.$t('dsfx.t52')
            item.index = index
          })
          that.tableData = _lists
          that.pagingtotal = rex.results[1][0].Count
          
          that.tableloading = false
        },
        error: function(response) {
          console.log('getLowpricedLists', response)
        }
			})
			
		},

    /**
     * 获取单品链接
     */
    getProductList: function(row){
      let that = this
      let url = this.API_URL + '/v3/price/monitorspu/skulist'
      let query = {
        subid: that.$route.params.Id,
        itemcode: row.itemcode,
        channelid: row.channelid
      }

      let _c = this.expands
      if(row.index == _c[0]) return
      this.expands = []
      this.expands.push(row.index)

      that.tableloading1 = true
      $.ajax({
        url:  url,
        type: "GET",
        data: query,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log(rex)
          let _list = rex.results[1]
          _list.forEach(item => {
            item.MarginPercent = (item.MarginPercent * 100).toFixed(2) + "%"
          })
          that.tableDataSku[row.index] = _list
          that.tableloading1 = false
        },
        error: function(response) {
          console.log(response)
        }
      })
    },

    /**
     * 查看详情
     */
    viewUrlDetail: function(mid, name, skuid){
      this.setLocalStorage( "SPUviewurlDetail", '' )
      let MidName = name
      this.setLocalStorage( "SPUviewurlDetail", MidName )
      this.$router.push({name: 'SPUViewUrlDetail1', params: {Id: this.$route.params.Id, SkuId: skuid, Mid: mid}})
    },

    /**
     * 判断是否一天内
     */
    chkCrawltime: function(ctime, ntime){
      if(ctime){
        if(this.$moment(ntime).diff(this.$moment(ctime),'hours') < 24){
          return true
        }else{
          return false
        }
      }else{
        return false
      }
    },

    /**
     * Priority Level
     */
    setPriorityLevel: function(amount, channelid){
      let str = ''
      if(channelid === 0){
        if(amount < 10000){
          str = this.$t('jgjk.s268')
        }
        if(amount >= 10000 && amount < 100000){
          str = this.$t('jgjk.s269')
        }
        if(amount >= 100000){
          str = this.$t('jgjk.s270')
        }
      }
      if(channelid === 1){
        if(amount < 1000){
          str = this.$t('jgjk.s268')
        }
        if(amount >= 1000 && amount < 50000){
          str = this.$t('jgjk.s269')
        }
        if(amount >= 50000){
          str = this.$t('jgjk.s270')
        }
      }
      return str
    },

    /**
     * 修改链接
     */
    editSkuLink: function(row){
      let that = this
      that.searchSku()
      that.editskulinkdialog = true
      that.options = []
      that.currentlinkeditcontent = row
    },

    /**
     * 确认修改SKU
     */
    editskulinkconfirm: function(){
      let that = this
      let url = that.API_URL + '/v3/price/statistics/updatesku'
      let query = {
        subid: that.$route.params.Id/1,
        channelId: that.currentlinkeditcontent.ChannelId,
        channel: that.currentlinkeditcontent.Channel,
        shopId: that.currentlinkeditcontent.ShopId,
        assetid: that.currentlinkeditcontent.AssetId,
        skuid: that.currentlinkeditcontent.SkuId,
        newskuid: that.newskuidradio/1 === 3 ? that.newskuid : that.newskuidradio,
        currentDate: JSON.parse(localStorage.getItem("latestupdatetimeeditsku")).val
      }
      console.log(query)
      $.ajax({
        url: url,
        type: "POST",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).val + ""
        },
        data: JSON.stringify(query),
        success: function(rex) {
          console.log('editskulinkconfirm', rex)
          that.editskulinkdialog = false
          that.options = []
          that.currentlinkeditcontent = {}
          that.newskuid = ''
          that.newskuidradio = ''
          that.$message({
            message: '修改成功',
            type: 'success'
          })
          that.tableviewModelChange()
          // window.location.reload()
        },
        error: function(response) {
          console.log('editskulinkconfirm', response)
        }
      })      
    },

    /**
     * 获取表头
     */
    requestTabAndDropdownData: function(){
      let that = this
      let url = that.API_URL + '/v3/price/statistics/filter'
      let data = {
        skuid: '',
        taskid: that.taskid,
        channel: that.filterselector[0].default,
        authorize: this.tableviewQuery.authorize,
        search: this.tableviewQuery.search,
      }
      $.ajax({
        url:  url,
        type: "GET",
        data: data,
        headers: {'Authorization': 'Bearer '+JSON.parse(localStorage.getItem("token")).val+''},
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          
          let selectdefaultval = {
            name : that.$t('tabletabs.all'),
            value : ''
          }
          that.filterselector[0].options = rex.results[1].map(function(val){
            return {
              name: that.setChannel(val.Channel).loc,
              value: val.Channel
            }
          })
          that.filterselector[0].options.unshift(selectdefaultval)

        },
        error: function(response) {
          console.log('getPageTopTrend-requestTabAndDropdownDataOld', response)
        }
      })      
    },
    
    onTableListSaerchClick: function(){
      this.currentPage1 = 1
      this.tableviewQuery.page = 1
      this.getLowpricedLists()
    },
		
	}
	
}
</script>
